import React, { useEffect, useMemo } from "react";
import LogNav from "../layout/LoggedNav";
import Tabs from "../layout/Tabs";
import Table from "../IncidentsLog/Table";
import Select from 'react-select';
import CustomSelect from "../layout/CustomSelect";

const SelectDrop = (props) => {
    const {selectedCourse, setSelectedCourse, courses,style1}=props
    const onChangeValue=(e)=>{
        setSelectedCourse(parseFloat(e.value))
    }

    return (
        <>
            <div className="custom-select-wrapper ">
                <div
                  style={style1?{minWidth: "30rem"}:{minWidth: "auto"}}
                    className="custom-select">
                    <CustomSelect
                        name="number_of_holes"
                        // name="number_of_holes"
                        options={ courses.map((c) => {
                            return { label: c.course_name,  value: c.id }
                        })}
                        placeholder="Select Course"
                        loading={false}
                        searchable={false}
                        onChange = {onChangeValue}
                        value={selectedCourse}
                    />
                </div>
            </div>


        </>
    );
};
export default SelectDrop;

